/* eslint-disable no-nested-ternary */
import React from "react";
import * as Styles from "./loading.styles";

interface LoadingProps {
  color?: string;
  size?: number;
  fullscreen?: boolean;
  fit?: boolean;
}

export const Loading = ({ color, size, fullscreen, fit }: LoadingProps) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: `${fit ? "fit-content" : "100%"}`,
        height: `${fullscreen ? "100vh" : fit ? "fit-content" : "100%"}`,
      }}
    >
      <Styles.Spinner size={size} color={color} />
    </div>
  );
};
